import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "", as: Tag = "span" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        <Tag>{children}</Tag>
      </motion.span>
    </span>
  );
}

export function SectionHead({ eyebrow, title, sub, align = "left", id, as = "h2" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  const MotionHeading = motion[as];
  return (
    <div ref={ref} className={`flex flex-col gap-4 ${alignCls} max-w-3xl ${align === "center" ? "" : ""}`} id={id}>
      <motion.div
        initial={{ opacity: 0, x: -16 }}
        animate={inView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.7, ease: EASE }}
        className="flex items-center gap-3"
      >
        <span className="h-px w-10 bg-gold/70" />
        <span className="eyebrow">{eyebrow}</span>
      </motion.div>
      <MotionHeading
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, delay: 0.08, ease: EASE }}
        className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground"
      >
        {title}
      </MotionHeading>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.16, ease: EASE }}
          className="text-base sm:text-lg text-muted-foreground leading-relaxed"
        >
          {sub}
        </motion.p>
      )}
    </div>
  );
}

export default Reveal;
